import { TrackIntelligentReminderMutation, IntelligentReminderParams } from '@water-web/api';

import { AnalyticsEvent } from '../events';
import { CommonPayload, isIntelligentReminderEvent, Tracker } from '../types';

export class IntelligentReminderTracker implements Tracker {
  private apiUrl: string;
  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  getName(): string {
    return 'IntelligentReminderTracker';
  }

  track(analyticsEvent: AnalyticsEvent, payload: CommonPayload): void {
    if (!isIntelligentReminderEvent(analyticsEvent, payload)) {
      return;
    }

    // Determine the event type and utm_content based on the analytics event
    let eventType: 'bookingStarted' | 'bookingCreated';
    let utmContent: 'book-again-started' | 'book-again-finished';

    if (analyticsEvent === AnalyticsEvent.INTELLIGENT_REMINDER_STARTED) {
      eventType = 'bookingStarted';
      utmContent = 'book-again-started';
    } else {
      eventType = 'bookingCreated';
      utmContent = 'book-again-finished';
    }

    const analyticsPayload: IntelligentReminderParams = {
      eventType,
      utmMedium: payload.utmMedium,
      utmSource: 'intelligent-reminder',
      utmContent,
      userAgent: this.getUserAgent(),
      userId: payload.userId,
      timeZone: this.getTimeZone(),
      metadata: {
        appointmentId: payload.appointmentId,
      },
    };

    const endpoint = new TrackIntelligentReminderMutation(this.apiUrl);
    endpoint.request(analyticsPayload);
  }

  private getUserAgent(): string | undefined {
    if (typeof window !== 'undefined' && window.navigator) {
      return window.navigator.userAgent;
    }
    return undefined;
  }

  private getTimeZone(): string {
    if (typeof window !== 'undefined') {
      try {
        // Always use offset calculation to get GMT+X format
        const offset = new Date().getTimezoneOffset();
        const hours = Math.abs(Math.floor(offset / 60));
        const minutes = Math.abs(offset % 60);
        const sign = offset <= 0 ? '+' : '-';

        // Format to match API expectation: GMT+2 instead of GMT+02:00
        if (minutes === 0) {
          return `GMT${sign}${hours}`;
        }
        return `GMT${sign}${hours}:${minutes.toString().padStart(2, '0')}`;
      } catch (e) {
        // Fallback
        return 'GMT+0';
      }
    }
    return 'GMT+0';
  }
}
